import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraAvatar } from '../ensigns/avatar';
import { SpecraText } from '../ensigns/typography';
/** Signed-in or assigned person summary with avatar, role, and actions. */ export function SpecraUserSummary({ actions, collapsed = false, name, role }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: collapsed ? 'flex justify-center' : 'flex items-center gap-2.5',
        children: [
            /*#__PURE__*/ _jsx(SpecraAvatar, {
                name: name,
                size: "sm"
            }),
            !collapsed ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0 flex-1",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraText, {
                                className: "block truncate font-medium",
                                size: "caption",
                                children: name
                            }),
                            role ? /*#__PURE__*/ _jsx(SpecraText, {
                                className: "block truncate",
                                size: "micro",
                                tone: "muted",
                                children: role
                            }) : null
                        ]
                    }),
                    actions
                ]
            }) : null
        ]
    });
}
